// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthService, PermissionState, User, UsersService } from '@fc-core';
import {
  currentUserError,
  logOutCurrentUserAction,
  retrieveCurrentUser,
  retrieveCurrentUserSuccess,
} from '../actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PermissionsService } from '@fc-core/services/permissions.service';
import { of } from 'rxjs';

@Injectable()
export class CurrentUserEffects {
  loadCurrentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(retrieveCurrentUser),
      switchMap(() => {
        return this.usersService
          .loadCurrentUser(this.auth.tokenData.user_id)
          .pipe(
            map((user: User) => {
              const permissions: PermissionState[] = user.permissions.map(
                (permission) => {
                  return {
                    ...permission,
                    active: true,
                  } as PermissionState;
                },
              );
              this.permissionsService.setPermissions(permissions);
              return retrieveCurrentUserSuccess({ user });
            }),
            catchError((err) => of(currentUserError(err))),
          );
      }),
    ),
  );

  logout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(logOutCurrentUserAction),
        map(() => {
          this.auth.logout();
          window.location.assign('/');
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private usersService: UsersService,
    private actions$: Actions,
    private auth: AuthService,
    private permissionsService: PermissionsService,
  ) {}
}
